import { createFileRoute } from '@tanstack/react-router';
import { useFlagsStatus } from '@unleash/proxy-client-react';
import clsx from 'clsx';
import { useEffect, useState } from 'react';

import { useAuth } from '@furality/frontend-stack';
import style from '@/components/fullscreen.module.scss';
import { NoLayout } from '@/components/layouts/index.tsx';
import PageLoading from '@/components/loading/PageLoading.tsx';
import PageDisabled from '@/components/PageDisabled.tsx';
import RegisteredWrapper from '@/components/RegisteredWrapper.tsx';
import { SURVEY_TYPEFORM_CODE } from '@/lib/constants.ts';
import useFlag from '@/lib/hooks/useFlag.ts';

const Survey = () => {
  const [loading, setLoading] = useState(true);

  const { user } = useAuth();

  const featuresReady = useFlagsStatus().flagsReady;
  const enablePostConSurvey = useFlag('postConSurvey');

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://embed.typeform.com/embed.js';
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleLoad = () => {
    setLoading(false);
  };

  if (!featuresReady) {
    return <PageLoading />;
  }

  if (!enablePostConSurvey) {
    return <PageDisabled absolutelyCentered />;
  }

  return (
    <RegisteredWrapper>
      {loading && <PageLoading />}
      <iframe
        title="survey-form"
        allow="camera; microphone; autoplay; encrypted-media;"
        src={`https://form.typeform.com/to/${SURVEY_TYPEFORM_CODE}?form_token_id=${user?.id}`}
        className={clsx('d-block', style['fullscreen'])}
        onLoad={handleLoad}
      ></iframe>
    </RegisteredWrapper>
  );
};

export const Route = createFileRoute('/survey')({
  component: () => (
    <NoLayout title="shared.navigation.survey">
      <Survey />
    </NoLayout>
  ),
});
